(function () {
	angular
		.module('trackeye')
		.factory('LimitationService', LimitationService);

	LimitationService.$inject = ["Limitation", "$http", "$q"];

	function LimitationService(Limitation, $http, $q) {
		var exports = {},
			definitions = {},
			promises = {};

		exports.get = function (device) {
			var defer = $q.defer(),
				ident = getIdent(device);

			if (!ident) {
				defer.resolve();
			} else {
				if (isOngoing(ident)) {
					return promises[ident].defer.promise;
				}

				if (hasDefinition(ident)) {
					defer.resolve(definitions[ident])
				} else {
					promises[ident] = {
						resolved: false,
						defer: defer
					};

					$http.get('/assets/json/' + ident + '.json').then(function (resp) {
						definitions[ident] = resp.data;

						defer.resolve(resp.data);
					}, defer.reject).finally(function() {
						promises[ident].resolved = true;
					});
				}
			}
			return defer.promise;
		};

		exports.instance = function () {
			return new Limitation();
		};

		/**
		 *
		 * @param {Device} device
		 * @returns {string|boolean}
		 */
		function getIdent(device) {
			var features = device.features;

			if (features.isRapid()) {
				if (device.getSubscription() == 21) {
					return "rapid_police";
				} else {
					return "rapid";
				}
			} else if (features.isSonic()) {
				return "sonic";
			} else if (features.isTamper()) {
				return "tamper";
			} else if (features.isRock()) {
				return "rock";
			} else if (features.isPower()) {
				return "power";
			}
			return false;
		}

		function isOngoing(ident) {
			if (angular.isDefined(promises[ident])) {
				return !promises[ident].resolved;
			}
			return false;
		}

		function hasDefinition(ident) {
			return angular.isDefined(definitions[ident]);
		}

		return exports;
	}
})();